export default __webpack_public_path__ + "static/media/TO.e0591082.svg";